<script>
import VJsoneditor from 'v-jsoneditor/src/index'

export default {

  components: {
    VJsoneditor
  },

  props: {
    trait: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      editMode: false
    }
  },

  methods: {
    toggleEditMode(event) {
      if (event.target.tagName == "INPUT") { return }
      this.editMode = !this.editMode
    }
  },

}
</script>

<template>
  <div>

    <div class="card">
      <div class="card-header" @click="toggleEditMode">
        <p class="card-header-title">
          <b-input v-model="trait.name" v-if="editMode" class="is-grow"></b-input>
          <span v-else>{{ trait.name }}</span>
        </p>
        <a class="card-header-icon">
          <b-button icon-left="pencil" size="is-small" :type="{'is-primary': editMode}"></b-button>
        </a>
      </div>
      <div class="content" v-if="editMode">
        <v-jsoneditor v-model="trait.params" :plus="false">
        </v-jsoneditor>
      </div>
    </div>

  </div>
</template>

<style lang="scss" scoped>
.card-header {
  cursor: pointer;
}
.is-grow {
  flex-grow: 1;
}
</style>